import type { UploadTask } from './AttachmentUploads';
import type { OnboardingImportReport } from '../../../api/account/accountApiTypes';

/**
 * What only "Einrichtung per Datei" needs: its file input and the uploads it
 * runs after the apply. The preview, its texts and the open points are shared
 * with "Organisationen importieren" (`components/importReport/`).
 */

/**
 * What the file input offers (PO, 2026-10-30): the onboarding file often
 * arrives as ".txt" after a download or a forwarded mail, and a picker
 * limited to ".json" greys it out. The server reads the content, never the
 * name, so any of these is fine.
 */
export const ONBOARDING_FILE_ACCEPT = '.json,.txt,application/json,text/plain';

/**
 * What to upload after the apply: the photos of every room the server names
 * (`rooms`, keyed by the room name exactly as the file and the preview write
 * it — so no name matching happens here), and the terms PDF when the server
 * planned it. A room without a cover — created now, or created by an earlier
 * apply whose answer was lost — gets its first photo as the cover (the
 * featured-image route); a room with one keeps it and gets further images.
 */
export const uploadTasksOf = (
    written: OnboardingImportReport,
    photos: Record<string, File[]>,
    termsOfUse: File | null,
): UploadTask[] => {
    const tasks: UploadTask[] = [];
    for (const [name, room] of Object.entries(written.rooms ?? {})) {
        (photos[name] ?? []).forEach((file, index) => tasks.push({
            id: `${room.assetId}-${index}`, kind: 'photo', room: name, assetId: room.assetId, file, featured: (room.created || !room.hasCover) && index === 0,
        }));
    }
    if (written.terms && termsOfUse) {
        tasks.push({ id: 'terms', kind: 'terms', title: written.terms.title, documentId: written.terms.documentId, file: termsOfUse });
    }
    return tasks;
};
